import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

import { COLOR_BLACK, COLOR_WH } from '../colors';
import { BORDER } from '../common';

export const getMuiIconButtonOverrides = (theme: Theme): ComponentsOverrides['MuiIconButton'] => ({
  root: {
    padding: 0,
    borderRadius: '50%',
    background: theme.themeColors.colorIconButtonOutlinedBackground,
    border: theme.themeColors.colorIconButtonOutlinedBorder,

    '&:hover': {
      background: theme.themeColors.colorIconButtonOutlinedBackgroundHover,
    },
  },
  colorSecondary: {
    background: theme.themeColors.colorIconButtonContainedBackground,
    color: COLOR_WH,
    border: 'none',
    '&.Mui-disabled': {
      background: theme.themeColors.colorIconButtonContainedBackground,
    },
  },
  colorInfo: {
    background: theme.themeColors.colorIconButtonTertiaryBackground,
    color: COLOR_WH,
    border: BORDER,
    borderColor: theme.themeColors.colorIconButtonTertiaryBorder,
    '&:hover': {
      svg: {
        path: { stroke: COLOR_BLACK },
      },
    },
    '&.Mui-disabled': {
      svg: {
        path: { stroke: theme.themeColors.colorIconButtonTertiaryBorder },
      },
    },
  },
  sizeSmall: {
    width: 46,
    height: 46,
  },
  sizeMedium: {
    width: 56,
    height: 56,
  },
  sizeLarge: {
    width: 60,
    height: 60,
  },
});

export const getMuiIconButtonDefaultProps = (): ComponentsProps['MuiIconButton'] => ({
  disableFocusRipple: true,
  disableRipple: true,
  size: 'medium',
});
